import axios from "axios";

const servicePrefix = "/galaxy";


// 更新用户配置表数据
export function updateUserConfiguration(parameter) {
    return axios({
        url: servicePrefix + `/userConfiguration/update`,
        method: 'POST',
        data: parameter
    })
}